import React from 'react';

// Ловит любую ошибку рендера в дочерних страницах.
// Показывает закрывающуюся карточку И сам текст ошибки со стеком —
// чтобы точную причину было видно прямо на экране (и можно было скопировать).
export default class ErrorBoundary extends React.Component {
    state = { hasError: false, error: null, errorInfo: null };

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('AppErrorBoundary:', error, errorInfo);
        this.setState({ error, errorInfo });
    }

    copyError = () => {
        const { error, errorInfo } = this.state;
        const text =
            'Ошибка: ' + (error && (error.stack || error.toString())) +
            '\n\nКомпонентный стек:' +
            (errorInfo && errorInfo.componentStack ? errorInfo.componentStack : '');
        try {
            navigator.clipboard.writeText(text);
        } catch (e) { /* ignore */ }
    };

    render() {
        if (!this.state.hasError) return this.props.children;

        const { error, errorInfo } = this.state;
        const message = error ? (error.stack || error.toString()) : 'Неизвестная ошибка';
        const componentStack = errorInfo && errorInfo.componentStack ? errorInfo.componentStack : '';

        return (
            <div style={{
                position: 'fixed', inset: 0, zIndex: 99999,
                display: 'flex', flexDirection: 'column',
                alignItems: 'center', justifyContent: 'center',
                gap: 14, padding: 24, textAlign: 'center', overflow: 'auto',
                background: 'var(--joy-palette-background-body, #0b0b12)',
                color: 'var(--joy-palette-text-primary, #fff)',
            }}>
                <div style={{ fontSize: 40 }}>⚠️</div>
                <div style={{ fontSize: 18, fontWeight: 700 }}>Что-то пошло не так</div>
                <div style={{ fontSize: 14, opacity: 0.7, maxWidth: 340 }}>
                    Произошла ошибка в интерфейсе. Обнови страницу — данные не потеряны.
                </div>

                <div style={{ display: 'flex', gap: 12, marginTop: 4, flexWrap: 'wrap', justifyContent: 'center' }}>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            padding: '10px 18px', borderRadius: 10, border: 'none',
                            cursor: 'pointer', background: '#a226e2', color: '#fff',
                            fontWeight: 700, fontSize: 14,
                        }}
                    >
                        Обновить
                    </button>
                    <button
                        onClick={() => { window.location.href = '/'; }}
                        style={{
                            padding: '10px 18px', borderRadius: 10, cursor: 'pointer',
                            background: 'transparent', color: 'inherit',
                            border: '1px solid rgba(255,255,255,0.25)',
                            fontWeight: 600, fontSize: 14,
                        }}
                    >
                        На главную
                    </button>
                    <button
                        onClick={this.copyError}
                        style={{
                            padding: '10px 18px', borderRadius: 10, cursor: 'pointer',
                            background: 'transparent', color: 'inherit',
                            border: '1px solid rgba(255,255,255,0.25)',
                            fontWeight: 600, fontSize: 14,
                        }}
                    >
                        Скопировать ошибку
                    </button>
                </div>

                {/* Текст ошибки и стек — виден прямо на экране */}
                <pre style={{
                    marginTop: 8, maxWidth: 720, width: '100%',
                    maxHeight: '40vh', overflow: 'auto',
                    textAlign: 'left', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                    fontSize: 12, lineHeight: 1.5,
                    padding: 14, borderRadius: 10,
                    background: 'rgba(255,255,255,0.05)',
                    border: '1px solid rgba(255,255,255,0.15)',
                    color: '#ffb4b4',
                }}>
{message}
{componentStack ? '\n— — —\nКомпонентный стек:' + componentStack : ''}
                </pre>
            </div>
        );
    }
}